import { put, select, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import { getServiceProvider, IServiceProvider } from '../../services';
import selectors from './selectors';
import { commonActions } from '../common';
import { ActionType } from '../../utils/reduxUtils';

function* saveTourStopOfflineStatus(action: ActionType<typeof actions.syncTourStopOfflineStatusAsync.request>) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  const syncId = action.payload;

  const statusWithSyncId = selectors.selectBySyncId(yield select(), syncId);

  if (statusWithSyncId.length === 0) {
    return;
  }

  try {
    yield serviceProvider.api.saveTourStopOfflineStatus(statusWithSyncId);
    yield put(actions.syncTourStopOfflineStatusAsync.success(syncId));
  } catch (e) {
    yield put(actions.syncTourStopOfflineStatusAsync.failure(syncId));
  }
}

const saveSaga = takeEvery(actions.syncTourStopOfflineStatusAsync.request.type, saveTourStopOfflineStatus);

/*
trigger sync whenever
- a new status is added
- the app loads (next session)
- or the internet connection is restored
 */
const addSaga = takeEvery(
  [commonActions.connection.online.type, commonActions.initApp.type, actions.addTourStopOfflineStatus.type],
  function* () {
    const randomSyncId = Math.random().toString(36).substring(2, 15);
    yield put(actions.syncTourStopOfflineStatusAsync.request(randomSyncId));
  }
);

const sagas = [saveSaga, addSaga];

export default sagas;
